import { fromJS } from 'immutable';

import * as ActionTypes from '../constants/ActionTypes';

const initialState = fromJS({
  linked_events: {},
});

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCHED_TOPIC:
      return state.mergeIn(
        ['linked_events'],
        fromJS(action.payload.entities.linked_events),
      );

    default:
      return state;
  }
};
